import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const PoliticaConfidentialitate = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      
      <main className="flex-grow pt-24 pb-16 bg-muted/30">
        <div className="container mx-auto px-4 sm:px-6 max-w-4xl">
          <h1 className="text-4xl sm:text-5xl font-bold text-primary mb-8 font-playfair">
            Politica de Confidențialitate
          </h1>
          
          <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground font-lora">
            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">1. Informații Colectate</h2>
              <p>Colectăm următoarele tipuri de informații: nume, adresă email, număr de telefon, adresă de livrare și informații despre comenzi.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">2. Utilizarea Informațiilor</h2>
              <p>Informațiile personale sunt utilizate exclusiv pentru procesarea comenzilor, comunicare cu clienții și îmbunătățirea serviciilor noastre.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">3. Protecția Datelor</h2>
              <p>Implementăm măsuri de securitate pentru protejarea datelor dumneavoastră personale împotriva accesului neautorizat.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">4. Partajarea Informațiilor</h2>
              <p>Nu vindem, nu închiriem și nu partajăm informațiile dvs. personale cu terțe părți, cu excepția situațiilor în care este necesar pentru livrarea comenzilor.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">5. Drepturile Dumneavoastră GDPR</h2>
              <p>Aveți dreptul de a accesa, rectifica, șterge sau restricționa prelucrarea datelor personale. Pentru exercitarea acestor drepturi, contactați-ne la idaco_traditional@yahoo.com</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-primary mb-4 font-playfair">6. Cookies</h2>
              <p>Utilizăm cookies pentru îmbunătățirea experienței de navigare. Puteți gestiona preferințele cookie prin setările browserului.</p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PoliticaConfidentialitate;
